import React, { useRef } from 'react';
import DropdownCustomDark from 'views/finance/moduleComponents/DropdownCustomDark';
import DropdownMultiselectDark from 'views/finance/moduleComponents/DropdownMultiselectDark';

// ##### FilterFlow Component #####
const FilterFlow = ({
  categories = [],
  selectedFlowCategL0,
  setSelectedFlowCategL0,
  selectedRangeType,
  setSelectedRangeType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  selectedYears,
  setSelectedYears,
  selectedMonths,
  setSelectedMonths,
  flowsYears,
  yearsRange,
}) => {

  // ##### Refs and constants  #####
  const dropdownRef = useRef(null);
  const yearDropdownRef = useRef(null);
  const monthDropdownRef = useRef(null);
  const rangeTypes = ['last 30 days', 'by year', 'by dates'];
  // Months as objects: value = '01', label = 'Jan', etc.
  const months = [
    { value: '01', label: 'Jan' },
    { value: '02', label: 'Feb' },
    { value: '03', label: 'Mar' },
    { value: '04', label: 'Apr' },
    { value: '05', label: 'May' },
    { value: '06', label: 'Jun' },
    { value: '07', label: 'Jul' },
    { value: '08', label: 'Aug' },
    { value: '09', label: 'Sep' },
    { value: '10', label: 'Oct' },
    { value: '11', label: 'Nov' },
    { value: '12', label: 'Dec' },
  ];

  // ##### Handle Range Type Change #####
  const handleRangeTypeChange = (newType) => {
    setSelectedRangeType(newType);
    if (newType !== 'by dates') {
      setStartDate('');
      setEndDate('');
    }
    // Note: Preserve selectedYears and selectedMonths values when switching modes
  };

  // ##### Parse Selected Years/Months #####
  const selectedYearsArray = selectedYears ? selectedYears.split('-').filter(Boolean) : [];
  const selectedMonthsArray = selectedMonths ? selectedMonths.split('-').filter(Boolean) : [];

  // ##### Render #####
  return (
    <div className="bg-gray-600 shadow rounded-xl overflow-hidden mb-2">
      <div className="px-2 py-3 flex items-center gap-2">

        {/* Category filter */}
        <div className="relative flex-1" ref={dropdownRef} data-portal="categ">
          <DropdownCustomDark
            options={categories}
            selectedValue={selectedFlowCategL0}
            onSelect={setSelectedFlowCategL0}
            placeholder="All"
            width="w-full"
            showRadio={true}
            usePortal={true}
            portalRef={dropdownRef}
            showAllOption={true}
            allOptionText="All"
            allOptionValue="All"
          />
        </div>

        {/* Period filter - Segmented Button */}
        <div className="bg-gray-500 bg-opacity-30 rounded-full p-0.5 flex">
          {rangeTypes.map((type, index) => (
            <button
              key={type}
              onClick={() => handleRangeTypeChange(type)}
              className={
                `px-3 py-1 text-xs font-medium transition-all ` +
                (index === 0 ? 'rounded-l-full' : index === rangeTypes.length - 1 ? 'rounded-r-full' : '') +
                (selectedRangeType === type
                  ? ' text-white bg-gray-500'
                  : ' text-white text-opacity-70 hover:text-opacity-100 hover:bg-gray-500 hover:bg-opacity-20')
              }
            >
              {type}
            </button>
          ))}
        </div>
      </div>

      {/* ##### Additional Filters (Expandable) ##### */}
      <div className={
        `overflow-hidden transition-all duration-200 ease-in-out ` +
        ((selectedRangeType === 'by dates' || selectedRangeType === 'by year') ? 'h-12' : 'h-0')
      }>
        <div className="h-12 px-2 flex items-center bg-gray-500 bg-opacity-20">

          {/* By Dates */}
          {selectedRangeType === 'by dates' && (
            <div className="flex items-center gap-2 w-full">
              <div className="flex-1 flex items-center gap-2">
                <label className="text-xs text-white opacity-70 whitespace-nowrap">Start</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                  className="w-full border-0 bg-gray-500 bg-opacity-30 rounded-md px-2 py-1 text-xs text-white focus:outline-none focus:ring-1 focus:ring-white focus:ring-opacity-30"
                />
              </div>
              <div className="flex-1 flex items-center gap-2">
                <label className="text-xs text-white opacity-70 whitespace-nowrap">End</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                  className="w-full border-0 bg-gray-500 bg-opacity-30 rounded-md px-2 py-1 text-xs text-white focus:outline-none focus:ring-1 focus:ring-white focus:ring-opacity-30"
                />
              </div>
            </div>
          )}

          {/* By Year */}
          {selectedRangeType === 'by year' && (
            <div className="flex items-center gap-2 w-full">
              <div className="flex-1 flex items-center gap-2">
                <DropdownMultiselectDark
                  options={(yearsRange && yearsRange.length ? yearsRange : flowsYears.map(String))}
                  selectedValues={selectedYearsArray}
                  onSelect={arr => setSelectedYears(arr.join('-'))}
                  placeholder="Select Year"
                  width="w-full"
                  usePortal={true}
                  portalRef={yearDropdownRef}
                />
              </div>
              <div className="flex-1 flex items-center gap-2">
                <DropdownMultiselectDark
                  options={months}
                  selectedValues={selectedMonthsArray}
                  onSelect={arr => setSelectedMonths(arr.join('-'))}
                  placeholder="Select Month"
                  width="w-full"
                  usePortal={true}
                  portalRef={monthDropdownRef}
                  gridCols="grid-cols-3"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterFlow;